module.exports = __webpack_public_path__ + "img/violet_107.23501273.png";